export const TRANSLATIONS_EN_US = {};
